import * as Scrivito from "scrivito";
import { useEffect } from "react";
import { useProjectDataStore } from "stores/projectStore";
import { useAppBaseContext } from "providers";

export const useRedirectOnError = () => {
  const error = useProjectDataStore((state) => state.error);
  const { isSameProj } = useAppBaseContext() as { isSameProj: boolean };

  const projectList = Scrivito.Obj.where(
    "_objClass",
    "equals",
    isSameProj ? "ProjectListSame" : "ProjectList",
  ).first();

  useEffect(() => {
    if (error && projectList) {
      Scrivito.navigateTo(projectList);
    }
  }, [error, projectList]);
};
